import { Attributes, Misc, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateSecurityTransferCommand extends ModelBase {

    public securityTransferID: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public transferEntryDate: Date | null = null;

    public fileGroupingIDFrom: number | null = null;

    @Rules.StringLength(50)
    public accountFrom: string = "";

    public fileGroupingIDTo: number | null = null;

    @Rules.StringLength(50)
    public accountTo: string = "";

    @Rules.StringLength(50)
    public clientPolicyNumber: string = "";

    @Rules.StringLength(100)
    public clientName: string = "";

    @Rules.StringLength(500)
    public notes: string = "";

    public isTaxableTransferInd: boolean = false;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public executionDate: Date | null = null;

    public transferStatus: string = "";

    public isDeletedInd: boolean = false;

    public isExternalInd: boolean = false;
}